import { z } from "zod";
export const itemTypes = [
    "Document",
    "Package",
    "Furniture",
    "Appliance",
    "Multiple items",
    "Other",
];
export const manwithvanSchema = z.object({
    itemType: z.enum(itemTypes, { message: "Select item type" }),
    description: z.string().min(1, "Required").max(500, "Max 500 characters"),
    weightKg: z.number().positive("Weight must be positive"),
    dimensions: z
        .object({
        length: z.number().nonnegative(),
        width: z.number().nonnegative(),
        height: z.number().nonnegative(),
    })
        .optional(),
    isFragile: z.boolean().optional(),
    requiresTwoPeople: z.boolean().optional(),
    helpers: z.number().int().min(0).max(3).optional(),
    hours: z.number().int().min(1).max(12).optional(),
    photos: z.array(z.string()).max(3, "Max 3 photos").optional(),
    notes: z.string().max(500).optional(),
});
//# sourceMappingURL=schema.js.map